module.exports = __webpack_public_path__ + "static/media/alert.5a3a50e7.svg";